import { useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

const DynamicFavicon = () => {
  useEffect(() => {
    const updateFavicon = async () => {
      try {
        const response = await axios.get(`${API_URL}/landing_page_api.php`);
        if (response.data.status === 'success') {
          const config = response.data.data.config || {};

          if (config.site_favicon) {
            // Convert relative path to absolute URL
            const faviconPath = config.site_favicon.startsWith('http')
              ? config.site_favicon
              : `${API_URL.replace('/api', '')}/${config.site_favicon}`;

            // Browsers (Chrome especially) often keep showing the originally
            // loaded favicon if you just mutate an existing <link>'s href -
            // remove the static one from index.html and any previous dynamic
            // one, then insert a fresh element so the change actually takes.
            document.querySelectorAll("link[rel~='icon']").forEach((el) => el.remove());
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = faviconPath;
            document.head.appendChild(link);

            // Update apple-touch-icon the same way
            document.querySelectorAll("link[rel='apple-touch-icon']").forEach((el) => el.remove());
            const appleTouchIcon = document.createElement('link');
            appleTouchIcon.rel = 'apple-touch-icon';
            appleTouchIcon.href = faviconPath;
            document.head.appendChild(appleTouchIcon);
          }

          // Update page title if configured
          if (config.site_logo_alt) {
            document.title = config.site_logo_alt;
          }
        }
      } catch (error) {
        console.error('Failed to fetch favicon:', error);
      }
    };

    updateFavicon();
  }, []);

  return null; // This component doesn't render anything
};

export default DynamicFavicon;
